module.exports = __webpack_public_path__ + "assets/images/book_e3d0d88096fe98e526e454d0c130aa73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/locales/centrooeste/book.png
// module id = 203
// module chunks = 0